import type { FaireProductEntity } from "../../entity_types/product";

export const p_xh3jhjv7rz: FaireProductEntity = {
  token: "p_xh3jhjv7rz",
  type: "product",
  name: "Baby Mitten - Pale Pink",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl: "https://cdn.faire.com/fastly/57dbdf1caaa07a5ab1f3b01c64ff19c6d5004f4186ff4169aa110b7a47d6c51c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5022bd9375cfe643aa27953680398c7f3134b0c765eb50fb82d7f3f55b54e779.jpeg",
    "https://cdn.faire.com/fastly/5339e136e7cd4892b3174eb485a656353f53b2b2cdf312bb53608349bc06a1d6.jpeg"
  ],
  priceDollars: 7.25,
  description: "GREAT QUALITY: Beautifully and softly knitted 100% acrylic with a plush sherpa lining. The mitten cuffs feature a ribbed design. Wash on a cold, delicate cycle and hang to dry. Great fit and extremely durable, for both little boys and little girls alike.\nGREAT FIT: These mittens are recommended for infants between 0-9 months and measure 4.5” x 2.5” laying flat, giving the baby's hands and fingers plenty of space to move flexibly inside the gloves without making them feel too tight or loose. Easy to put on and take off, these accessories are suitable for both baby boys and baby girls alike.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:15.468Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
